import { JobLeaveStatus } from "types/JobLeave";

export const ALL_JOB_LEAVE_STEPS = [
  "step_assets",
  "step_leaves",
  "step_signatures",
  "step_permissions",
] as const;

export type JobLeaveStep = (typeof ALL_JOB_LEAVE_STEPS)[number];

export const JOB_LEAVE_STEP_LABELS: Record<
  JobLeaveStep,
  { lt: string; en: string }
> = {
  step_assets: { lt: "Turtas", en: "Assets" },
  step_leaves: { lt: "Atostogos", en: "Leave requests" },
  step_signatures: { lt: "Parašai", en: "Signatures" },
  step_permissions: { lt: "Teisės", en: "Permissions" },
};

export function normalizeJobLeaveStatus(
  status: JobLeaveStatus | string | undefined
): JobLeaveStatus {
  if (status === "in_progress") return "step_assets";
  return (status as JobLeaveStatus) || "step_assets";
}

export function getJobLeaveStatusTone(
  status: JobLeaveStatus | string | undefined
): "info" | "success" | "critical" | "warning" | "attention" {
  const s = normalizeJobLeaveStatus(status);
  switch (s) {
    case "step_assets":
    case "step_leaves":
    case "step_signatures":
    case "step_permissions":
      return "attention";
    case "completed":
      return "success";
    case "cancelled":
      return "critical";
    default:
      return "info";
  }
}

export function getJobLeaveStatusLabel(
  status: JobLeaveStatus | string | undefined,
  t: (key: string) => string,
  lang: "lt" | "en" = "en"
) {
  const s = normalizeJobLeaveStatus(status);
  if (s === "completed") return t("completed");
  if (s === "cancelled") return t("cancelled");
  if (JOB_LEAVE_STEP_LABELS[s as JobLeaveStep]) {
    return (
      JOB_LEAVE_STEP_LABELS[s as JobLeaveStep][lang] ||
      JOB_LEAVE_STEP_LABELS[s as JobLeaveStep].en
    );
  }
  return s;
}

export function getJobLeaveStepIndex(status: JobLeaveStatus | string | undefined) {
  const s = normalizeJobLeaveStatus(status);
  return ALL_JOB_LEAVE_STEPS.indexOf(s as JobLeaveStep);
}
